import { render } from "./Revoked.vue?vue&type=template&id=b48ec240"
import script from "./Revoked.vue?vue&type=script&lang=js"
export * from "./Revoked.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__